import { Component } from 'preact';

const OptionCard = props => {
	const { question, submitting, id, active, options, index, next, set, lastCard } = props;
	return (
		<div className="option-card">
			<h2>{question}</h2>
			<div className="slide-options options">
				{
					options.map( option => {
						return (
							<div className="option">
								<input
									disabled={submitting}
									name={`option-${index}`}
									type="radio"
									id={option.value}
									value={option.value}
									class="hide"
									onChange={ e => set(id, e.target.value) }
								/>
								<label for={option.value}>{option.label}</label>
							</div>
						)
					})
				}
			</div>
			<button disabled={!active || submitting} onClick={next}>{ lastCard ? submitting ? 'Finishing' : 'Finish' : 'Submit'}</button>
		</div>
	)
}

export default OptionCard


// WEBPACK FOOTER //
// ./components/cards/option-card/index.js